import { useState, useEffect, useMemo } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";
import SoftBox from "components/SoftBox";
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";
import theme from "assets/theme";
import routes from "routes";
import { useSoftUIController, setMiniSidenav, setOpenConfigurator } from "context";
import brand from "assets/images/logo.png";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./firebase/firebase-config";
import Message from "./components/message";
import toast from "react-hot-toast";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { jwtDecode } from "jwt-decode";
import "./style.css";
import SignUp from "layouts/authentication/sign-up";
import { ChangeThemeOnRedux } from "api/commonSlice";
import { useDispatch } from "react-redux";
import Subscriptions from "layouts/Subscriptions";
import CheckoutReturn from "layouts/checkoutReturn/index";
import Interceptor from "./admin/api/interceptor";
import ProtectedRoute from "components/ProtectedRoute";
export default function App() {

  const dispatcho = useDispatch();
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, direction, layout, openConfigurator, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();

  onMessage(messaging, (payload) => {
    toast.success(<Message notification={payload.notification} />);
  });



  const navigate = useNavigate();
  const isToken = localStorage.getItem('token');

  useEffect(() => {
    const theme = localStorage.getItem('theme') || 'light';
    if (theme === 'light') {
      dispatcho(ChangeThemeOnRedux('light'))
      document.body.classList.add('light-mode');
    } else {
      dispatcho(ChangeThemeOnRedux('dark'))
      document.body.classList.add('dark-mode');
    }
  }, []);

  // useEffect(() => {
  //   if (isToken) {
  //     const decodedToken = jwtDecode(isToken);
  //     const currentTime = Date.now() / 1000;
  //   }
  // }, []);

  useEffect(() => {
    if (isToken == null) {
      const allowedPaths = [
        "/register",
        "/admin/register",
        "/forgot-password",
        "/admin/forgot-password",
        "/subscriptions",
        "/resetPassword",
        "/verifyEmail",
        "/checkout-return"
      ];

      if (!allowedPaths.includes(pathname)) {
        navigate("/login");
      }
    }
  }, [navigate, isToken, pathname]);


  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);
  const userScope = useMemo(() => localStorage.getItem("scope"), []);
  const getRoutes = (allRoutes) =>
    allRoutes.flatMap((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse); // recursion continues
      }

      if (route.route) {
        return <Route exact path={route.route} element={<ProtectedRoute allowedScopes={[route.scope]}>
          {route.component}
        </ProtectedRoute>} key={route.key || route.route} />;
      }

      return [];
    });
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {layout === "dashboard" && !pathname.includes('/checkout-return') && (
        <>
          <Sidenav
            color={'info'}
            brand={brand}
            brandName="Thali App"
            routes={routes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />

        </>
      )}
      <Interceptor />
      <Routes>
        {getRoutes(routes)}
        <Route path="/register" element={<SignUp />} />
        <Route path="/subscriptions" element={<Subscriptions />} />
        <Route path="/checkout-return" element={<CheckoutReturn />} />
        {userScope === '1' ?
          <Route path="*" element={<Navigate to="/admin/dashboard" />} />
          :
          <Route path="*" element={<Navigate to="/dashboard" />} />
        }
      </Routes>

    </ThemeProvider>
  );
}
